import { getOrgDetailsRequest } from '@/api/orgApi'
import { normalizeOrgDetailsPayload } from '@/utils/session'
import { getApiMessage, isApiSuccess } from '@/mixins/Extras/ApiResponse'

export async function loadOrgDetailsIntoStore(store) {
  store.commit('SET_ORG_DETAILS_LOADING', true)
  try {
    const raw = await getOrgDetailsRequest()
    if (!isApiSuccess(raw)) {
      throw new Error(getApiMessage(raw, 'Failed to load organisation details'))
    }

    const organization = normalizeOrgDetailsPayload(raw)
    if (!organization) {
      throw new Error('Organisation details are unavailable.')
    }

    store.commit('UPDATE_ORGANIZATION', organization)
    store.commit('SET_ORG_DETAILS_LOADED', true)
    return organization
  } finally {
    store.commit('SET_ORG_DETAILS_LOADING', false)
  }
}
